import { z } from "zod";

export const USER_STATUS_VALUES = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const;

export const UserStatusSchema = z.enum(USER_STATUS_VALUES);

export type UserStatus = z.infer<typeof UserStatusSchema>;

export const UserStatus = {
  ...USER_STATUS_VALUES,
} as const;
